<template>
  <div class="new-main-footer-revamp__item__child">
    <div class="new-main-footer-revamp__item__child__wrapper">
      <div class="new-main-footer-revamp__item__child__title">
        Layanan kami
      </div>
      <div
        v-if="services.length > 0"
        class="sitemap"
      >
        <component
          :is="nav.link.startsWith('http://') || nav.link.startsWith('https://') ? 'a' : 'router-link'"
          v-for="nav in services"
          :key="nav.title"
          name="spanServices"
          :to="nav.link"
          :href="nav.link"
          :target="nav.link.startsWith('http://') || nav.link.startsWith('https://') ? '_blank' : '_self'"
        >
          {{ nav.title }}
        </component>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OurServicesFooter",
  data() {
    return {
      services: [
        {
          title: "Pengiriman",
          link: "/product",
        },
        {
          title: "Pengiriman Internasional",
          link: "/lokasi-agen/pengiriman-internasional",
        },
        {
          title: "COD",
          link: "/cod",
        },
        {
          title: "Fulfillment",
          link: "/lilo",
        },
        {
          title: "Korporasi",
          link: "/korporasi",
        },
        {
          title: "Customer Apps",
          link: "#",
        },
        {
          title: "Mitra",
          link: "/agen",
        },
        {
          title: "Loyalty Program",
          link: "#",
        },
        {
          title: "Pintoko",
          link: "https://pintoko.com/",
        },
      ],
    }
  },
}
</script>
